const Loader = () => {
    return (
        <div className="loader__container">
            <div className="loader__container__item"></div>
        </div>
    );
}

export default Loader;